import { BaseCard } from '@/shared/components'
import { useIsMobile } from '@/shared/utils/useIsMobile/useIsMobile'

export type InfoCard = {
  id: number
  key: string
  value: string | number
}

type Props = {
  infoCards: InfoCard[]
}

export const InformationStatisticCards = ({ infoCards }: Props) => {
  const isMobile = useIsMobile()

  return (
    <div className="flex md:flex-row flex-col gap-x-4 gap-y-[10px] p-0.5 pb-2 md:max-w-[700px] lg:max-w-[900px] 2xl:max-w-[1200px] overflow-x-auto whitespace-nowrap custom-scrollbar">
      {infoCards.map((card) => (
        <BaseCard
          key={card.id}
          variant="secondary"
          padding={isMobile ? 'xs' : 'rsm'}
          className="flex flex-col gap-y-2 md:gap-y-4"
          radius="md"
        >
          <span className="text-text-secondary">{card.key}</span>
          <span className="font-klein font-medium text-main-black dark:text-white">
            {card.value}
          </span>
        </BaseCard>
      ))}
    </div>
  )
}
